import { render, staticRenderFns } from "./DeliveryOngoing.vue?vue&type=template&id=20e043aa&scoped=true&"
import script from "./DeliveryOngoing.vue?vue&type=script&lang=js&"
export * from "./DeliveryOngoing.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOngoing.vue?vue&type=style&index=0&id=20e043aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e043aa",
  null
  
)

export default component.exports